'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetScrollPercentage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getMessage = require('conversations-schema/operators/widget-data/getMessage');

var _getClientTriggers = require('conversations-schema/operators/message/getClientTriggers');

var _clientTriggersGetters = require('conversations-schema/client-triggers/operators/clientTriggersGetters');

var _scrollPercentageTriggerGetters = require('conversations-schema/client-triggers/operators/scrollPercentageTriggerGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTargetScrollPercentage = exports.getTargetScrollPercentage = function getTargetScrollPercentage(widgetData) {
  return (0, _pipe2.default)(_getMessage.getMessage, _getClientTriggers.getClientTriggers, _clientTriggersGetters.getDisplayOnScrollPercentage, _scrollPercentageTriggerGetters.getScrollPercentage)(widgetData);
};